import { Link } from "react-router-dom";
import { ArrowLeft, Printer } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LIVE_URL = process.env.REACT_APP_BACKEND_URL?.replace('/api', '').replace('api/', '') || window.location.origin;
const siteQR = `${API}/qrcode?url=${encodeURIComponent(LIVE_URL)}`;

const FlyersPage = () => {
  const handlePrint = (flyerId) => {
    const el = document.getElementById(flyerId);
    const win = window.open("", "_blank");
    if (!win) return;
    win.document.title = "Print Flyer";
    const style = win.document.createElement("style");
    style.textContent = "body{margin:0;padding:0;} img{max-width:100%;}";
    win.document.head.appendChild(style);
    win.document.body.innerHTML = el.outerHTML;
    setTimeout(() => { win.print(); }, 500);
  };

  return (
    <div className="min-h-screen bg-brand-bg" data-testid="flyers-page">
      <header className="border-b border-brand-border bg-brand-surface px-6 py-4 flex items-center justify-between">
        <Link to="/admin" className="font-serif text-xl text-brand-text">
          Afro <span className="text-brand-gold">Magic</span>
        </Link>
        <Link to="/admin" className="flex items-center gap-1 font-sans text-xs text-brand-text-muted hover:text-brand-gold">
          <ArrowLeft size={14} /> Admin
        </Link>
      </header>

      <div className="max-w-5xl mx-auto px-6 py-10">
        <div className="text-center mb-10">
          <h1 className="font-serif text-3xl text-brand-text mb-2">Printable Flyers</h1>
          <p className="font-sans text-sm text-brand-text-muted">Click "Print" to save as PDF or send to printer</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">

          {/* FLYER 1: Main Booking Flyer */}
          <div>
            <div className="flex items-center justify-between mb-3">
              <h2 className="font-sans text-sm text-brand-text-muted">Booking Flyer</h2>
              <button onClick={() => handlePrint('flyer1')} className="flex items-center gap-1.5 px-4 py-1.5 bg-brand-gold text-black font-sans text-xs font-semibold hover:bg-brand-gold-light transition-colors" data-testid="print-flyer-1">
                <Printer size={12} /> Print / Save PDF
              </button>
            </div>
            <div id="flyer1" style={{ width: '500px', minHeight: '700px', background: '#0F0C09', color: '#FDFBF7', fontFamily: 'Georgia, serif', padding: '40px', border: '2px solid #D4AF37', position: 'relative', overflow: 'hidden' }}>
              {/* Gold corner accents */}
              <div style={{ position: 'absolute', top: 0, left: 0, width: '80px', height: '80px', borderTop: '3px solid #D4AF37', borderLeft: '3px solid #D4AF37' }} />
              <div style={{ position: 'absolute', top: 0, right: 0, width: '80px', height: '80px', borderTop: '3px solid #D4AF37', borderRight: '3px solid #D4AF37' }} />
              <div style={{ position: 'absolute', bottom: 0, left: 0, width: '80px', height: '80px', borderBottom: '3px solid #D4AF37', borderLeft: '3px solid #D4AF37' }} />
              <div style={{ position: 'absolute', bottom: 0, right: 0, width: '80px', height: '80px', borderBottom: '3px solid #D4AF37', borderRight: '3px solid #D4AF37' }} />

              <div style={{ textAlign: 'center', marginBottom: '25px' }}>
                <img src="/logos/v1_emblem.png" alt="Afro Magic Braiding Hair" style={{ width: '160px', height: '160px', objectFit: 'contain', display: 'block', margin: '0 auto 10px' }} />
                <div style={{ width: '60px', height: '2px', background: '#D4AF37', margin: '15px auto' }} />
                <p style={{ fontSize: '13px', color: '#D4AF37', letterSpacing: '3px', fontFamily: 'Arial, sans-serif' }}>WHERE EVERY BRAID IS MAGIC</p>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', marginBottom: '20px', fontFamily: 'Arial, sans-serif' }}>
                {[
                  ['Knotless Braids', '$180'],
                  ['Box Braids', '$180'],
                  ['Fulani Braids', '$180'],
                  ['Boho Braids', '$210'],
                  ['Faux Locs', '$170'],
                  ['Cornrows', '$50'],
                  ['Crochet', '$130'],
                  ["Men's Styles", '$50'],
                ].map(([name, price]) => (
                  <div key={name} style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 10px', borderBottom: '1px solid #2C241D' }}>
                    <span style={{ fontSize: '12px', color: '#D6CFC4' }}>{name}</span>
                    <span style={{ fontSize: '12px', color: '#D4AF37', fontWeight: 'bold' }}>{price}</span>
                  </div>
                ))}
              </div>

              <div style={{ textAlign: 'center', background: 'rgba(212,175,55,0.1)', border: '1px solid rgba(212,175,55,0.3)', padding: '15px', marginBottom: '20px' }}>
                <p style={{ fontSize: '18px', color: '#D4AF37', fontWeight: 'bold', margin: '0 0 5px 0' }}>BOOK ONLINE IN 60 SECONDS</p>
                <p style={{ fontSize: '11px', color: '#D6CFC4', margin: 0, fontFamily: 'Arial, sans-serif' }}>Only a $25 deposit — it counts toward your total</p>
              </div>

              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '20px', marginBottom: '20px' }}>
                <div style={{ textAlign: 'center' }}>
                  <img src={siteQR} alt="Scan to View & Book" style={{ width: '120px', height: '120px', border: '2px solid #D4AF37', padding: '5px' }} />
                  <p style={{ fontSize: '10px', color: '#D4AF37', marginTop: '5px', fontFamily: 'Arial, sans-serif' }}>SCAN TO VIEW & BOOK</p>
                </div>
              </div>

              <div style={{ textAlign: 'center', borderTop: '1px solid #2C241D', paddingTop: '15px', fontFamily: 'Arial, sans-serif' }}>
                <p style={{ fontSize: '13px', color: '#D4AF37', fontWeight: 'bold', margin: '0 0 5px 0' }}>(313) 484-7307</p>
                <p style={{ fontSize: '11px', color: '#D6CFC4', margin: '0 0 3px 0' }}>22560 Telegraph Rd, Southfield, MI 48033</p>
                <p style={{ fontSize: '11px', color: '#D6CFC4', margin: 0 }}>afromagicbraiding.shop</p>
              </div>
            </div>
          </div>

          {/* FLYER 2: Promo / Social Media Flyer */}
          <div>
            <div className="flex items-center justify-between mb-3">
              <h2 className="font-sans text-sm text-brand-text-muted">Promo Flyer</h2>
              <button onClick={() => handlePrint('flyer2')} className="flex items-center gap-1.5 px-4 py-1.5 bg-brand-gold text-black font-sans text-xs font-semibold hover:bg-brand-gold-light transition-colors" data-testid="print-flyer-2">
                <Printer size={12} /> Print / Save PDF
              </button>
            </div>
            <div id="flyer2" style={{ width: '500px', minHeight: '700px', background: '#0F0C09', color: '#FDFBF7', fontFamily: 'Georgia, serif', padding: '40px', border: '2px solid #D4AF37', textAlign: 'center' }}>
              <div style={{ marginBottom: '30px' }}>
                <p style={{ fontSize: '14px', color: '#D4AF37', letterSpacing: '4px', fontFamily: 'Arial, sans-serif', margin: '0 0 10px 0' }}>INTRODUCING</p>
                <h1 style={{ fontSize: '38px', color: '#D4AF37', margin: '0 0 5px 0' }}>AFRO MAGIC</h1>
                <h2 style={{ fontSize: '20px', color: '#FDFBF7', margin: 0, fontWeight: 400 }}>Braiding Hair</h2>
                <div style={{ width: '100px', height: '1px', background: 'linear-gradient(to right, transparent, #D4AF37, transparent)', margin: '20px auto' }} />
              </div>

              <div style={{ background: '#D4AF37', color: '#000', padding: '20px', margin: '0 -10px 25px', transform: 'skewY(-1deg)' }}>
                <div style={{ transform: 'skewY(1deg)' }}>
                  <p style={{ fontSize: '28px', fontWeight: 'bold', margin: '0 0 5px 0', fontFamily: 'Georgia, serif' }}>BOOK ONLINE</p>
                  <p style={{ fontSize: '14px', margin: 0, fontFamily: 'Arial, sans-serif' }}>$25 Deposit Secures Your Spot</p>
                </div>
              </div>

              <p style={{ fontSize: '14px', color: '#D6CFC4', lineHeight: '1.8', marginBottom: '25px', fontFamily: 'Arial, sans-serif' }}>
                Premium African Hair Braiding<br />
                Knotless Braids &bull; Box Braids &bull; Boho Braids<br />
                Fulani Braids &bull; Faux Locs &bull; Cornrows<br />
                Crochet Styles &bull; Men's Braiding
              </p>

              <div style={{ marginBottom: '25px' }}>
                <img src={siteQR} alt="Scan to Book" style={{ width: '120px', height: '120px', border: '3px solid #D4AF37', padding: '8px' }} />
                <p style={{ fontSize: '12px', color: '#D4AF37', marginTop: '8px', fontFamily: 'Arial, sans-serif', fontWeight: 'bold' }}>SCAN TO VIEW & BOOK</p>
              </div>

              <div style={{ borderTop: '1px solid #2C241D', paddingTop: '20px', fontFamily: 'Arial, sans-serif' }}>
                <p style={{ fontSize: '16px', color: '#D4AF37', fontWeight: 'bold', margin: '0 0 8px 0' }}>(313) 484-7307</p>
                <p style={{ fontSize: '12px', color: '#D6CFC4', margin: '0 0 3px 0' }}>22560 Telegraph Rd, Southfield, MI 48033</p>
                <p style={{ fontSize: '12px', color: '#D6CFC4', margin: '0 0 8px 0' }}>afromagicbraiding.shop</p>
                <div style={{ display: 'flex', justifyContent: 'center', gap: '15px', fontSize: '11px', color: '#D4AF37' }}>
                  <span>@afromagicbraidinghair</span>
                </div>
              </div>
            </div>
          </div>

          {/* FLYER 3: Table Card / Small Flyer */}
          <div>
            <div className="flex items-center justify-between mb-3">
              <h2 className="font-sans text-sm text-brand-text-muted">Table Card (Small)</h2>
              <button onClick={() => handlePrint('flyer3')} className="flex items-center gap-1.5 px-4 py-1.5 bg-brand-gold text-black font-sans text-xs font-semibold hover:bg-brand-gold-light transition-colors" data-testid="print-flyer-3">
                <Printer size={12} /> Print / Save PDF
              </button>
            </div>
            <div id="flyer3" style={{ width: '350px', minHeight: '250px', background: '#0F0C09', color: '#FDFBF7', fontFamily: 'Georgia, serif', padding: '25px', border: '2px solid #D4AF37', textAlign: 'center' }}>
              <h1 style={{ fontSize: '20px', color: '#D4AF37', margin: '0 0 3px 0' }}>AFRO MAGIC BRAIDING HAIR</h1>
              <div style={{ width: '40px', height: '1px', background: '#D4AF37', margin: '10px auto' }} />
              <p style={{ fontSize: '16px', color: '#FDFBF7', margin: '0 0 5px 0', fontWeight: 'bold' }}>Book Online in 60 Seconds</p>
              <p style={{ fontSize: '10px', color: '#D6CFC4', margin: '0 0 15px 0', fontFamily: 'Arial, sans-serif' }}>Scan the QR code below</p>
              <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '15px' }}>
                <div>
                  <img src={siteQR} alt="View & Book" style={{ width: '100px', height: '100px', border: '2px solid #D4AF37', padding: '3px' }} />
                  <p style={{ fontSize: '9px', color: '#D4AF37', marginTop: '3px', fontFamily: 'Arial, sans-serif' }}>SCAN TO VIEW & BOOK</p>
                </div>
              </div>
              <p style={{ fontSize: '11px', color: '#D4AF37', margin: 0, fontFamily: 'Arial, sans-serif' }}>(313) 484-7307 | afromagicbraiding.shop</p>
            </div>
          </div>

          {/* FLYER 4: Instagram Story Size */}
          <div>
            <div className="flex items-center justify-between mb-3">
              <h2 className="font-sans text-sm text-brand-text-muted">Social Media Story</h2>
              <button onClick={() => handlePrint('flyer4')} className="flex items-center gap-1.5 px-4 py-1.5 bg-brand-gold text-black font-sans text-xs font-semibold hover:bg-brand-gold-light transition-colors" data-testid="print-flyer-4">
                <Printer size={12} /> Print / Save PDF
              </button>
            </div>
            <div id="flyer4" style={{ width: '300px', minHeight: '533px', background: '#0F0C09', color: '#FDFBF7', fontFamily: 'Georgia, serif', padding: '30px 25px', border: '2px solid #D4AF37', textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
              <div>
                <img src="/logos/v2_monogram.png" alt="A M B monogram" style={{ width: '110px', height: '110px', objectFit: 'contain', display: 'block', margin: '0 auto 12px' }} />
                <p style={{ fontSize: '11px', color: '#D4AF37', letterSpacing: '3px', fontFamily: 'Arial, sans-serif', margin: '0 0 15px 0' }}>AFRO MAGIC BRAIDING HAIR</p>
                <h1 style={{ fontSize: '32px', color: '#FDFBF7', margin: '0 0 5px 0', lineHeight: 1.1 }}>Where Every Braid is Magic</h1>
                <div style={{ width: '50px', height: '2px', background: '#D4AF37', margin: '15px auto 20px' }} />
                <div style={{ background: '#D4AF37', color: '#000', padding: '12px', marginBottom: '20px' }}>
                  <p style={{ fontSize: '20px', fontWeight: 'bold', margin: 0 }}>BOOK ONLINE TODAY</p>
                </div>
              </div>
              <div>
                <img src={siteQR} alt="Book" style={{ width: '100px', height: '100px', border: '2px solid #D4AF37', padding: '5px', marginBottom: '10px' }} />
                <p style={{ fontSize: '11px', color: '#D4AF37', fontFamily: 'Arial, sans-serif', fontWeight: 'bold', margin: '0 0 5px 0' }}>SCAN TO VIEW & BOOK</p>
                <p style={{ fontSize: '10px', color: '#D6CFC4', fontFamily: 'Arial, sans-serif', margin: 0 }}>(313) 484-7307</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default FlyersPage;
